import { BaseUsecaseLogic } from "../BaseUsecaseLogic";
import { UsecaseValidationMessage } from "../UsecaseValidationMessage";

/**
 * BoardUsecase currrently has no client-side logic:
 * It just forces the IR code to 308
 */
export class BoardUsecaseLogic extends BaseUsecaseLogic {

  /** Gets validation message for BoardUsecaseLogic  */
  public getUcValidation(): UsecaseValidationMessage {
    return null;
  }

}
